var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "price-card" },
    [
      _c(
        "div",
        [
          _c("h5", { staticClass: "title" }, [
            _c("img", {
              staticStyle: { height: "35px" },
              attrs: { src: _vm.icons[_vm.product.type], alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("product-details", {
            attrs: {
              upsellCardType: _vm.upsellCardType,
              product: _vm.product,
              "currency-is-changing": _vm.currencyIsChanging,
              "show-terms-and-conditions": _vm.showTermsAndConditions,
              vehicle: _vm.vehicle,
              experiment: _vm.experiment,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "p",
          { staticClass: "price-card-total" },
          [
            _vm.loyaltyHigherThanPromo
              ? _c(
                  "gm-tooltip",
                  {
                    staticClass: "d-inline-block",
                    attrs: {
                      text: _vm.labels.loyaltyAppliedInsteadOfPromo,
                      click: "enabled",
                    },
                  },
                  [_c("i", { staticClass: "fa fa-info-circle text-brand" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.product.original_price && !_vm.currencyIsChanging
              ? _c("strong", { staticClass: "original-amount" }, [
                  _vm._v(_vm._s(_vm.originalPrice(_vm.product))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currencyIsChanging
              ? _c("strong", { staticClass: "amount" }, [_vm._v("…")])
              : _c("strong", { staticClass: "amount" }, [
                  _vm._v(_vm._s(_vm.vehiclePrice)),
                ]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.labels.extraPerDay))]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.product.is_available
          ? _c("div", { staticClass: "desktop-choose-product" }, [
              _vm.keylessLoginRequired &&
              !_vm.user &&
              _vm.vehicle.is_drive_and_go
                ? _c(
                    "div",
                    {
                      staticClass: "choose-product col-12",
                      class: _vm.product.type,
                      on: {
                        click: function ($event) {
                          return _vm.handleLogin()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("bookings.login_register")) +
                          "\n                "
                      ),
                      _vm.product.type === "PMP"
                        ? _c("img", {
                            attrs: {
                              src: _vm.brandingImagesPath(
                                "/images/large-arrow-white.svg"
                              ),
                              alt: "right arrow white",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: _vm.brandingImagesPath(
                                "/images/large-arrow-green.svg"
                              ),
                              alt: "right arrow green",
                            },
                          }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              (!_vm.keylessLoginRequired && _vm.product.is_available) ||
              (_vm.user &&
                _vm.vehicle.is_drive_and_go &&
                _vm.product.is_available) ||
              (!_vm.vehicle.is_drive_and_go && _vm.product.is_available)
                ? _c(
                    "div",
                    {
                      staticClass: "choose-product",
                      on: {
                        click: function ($event) {
                          return _vm.selectVehicle(_vm.vehicle, _vm.product.id)
                        },
                      },
                    },
                    [
                      _vm.vehicle.external_id === _vm.vehicleExternalId &&
                      _vm.selectedProductType === _vm.product.type
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link-outline text-capitalize btn-main p-3",
                              on: { click: _vm.returnToBooking },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("PriceCard.current_choice")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm.product.type === "BAS"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link-outline text-capitalize btn-main p-3",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.bookNowLabel) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm.product.type === "PMP"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary text-capitalize btn-pmp p-3",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.bookNowLabel) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm.isFullModification
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary text-capitalize btn-pmp p-3",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.bookNowLabel) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.product.is_available
        ? _c(
            "gm-button",
            {
              attrs: {
                "top-right-radius": "0",
                "top-left-radius": "0",
                disabled: true,
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("PriceCard.minimum_age", {
                      age: _vm.product.minimum_age,
                    })
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }